/**
 * Hand a custom-scheme URL (e.g. claude-cli://) to the OS protocol handler
 * without navigating the SPA. Setting window.location.href unmounts the app
 * and can read as a route change; a transient anchor click does not.
 */
export function openDeepLink(url: string) {
	const anchor = document.createElement("a")
	anchor.href = url
	anchor.rel = "noopener"
	anchor.style.display = "none"
	document.body.appendChild(anchor)
	anchor.click()
	anchor.remove()
}
